import 'css/formDIHeaderResponsive.css';
import 'css/mobileSidebarDropdown.css';
import 'css/formDIDecaResponsive.css';
import React, { useCallback, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { TodayIs } from 'components/utils/TodayIs';
import ImportScript from 'components/utils/ImportScript';
import Footer from 'pages/main/Footer';
import Alerts from 'pages/alerts/Alerts';
import Messages from 'pages/messages/Messages';
import Person from 'pages/main/Person';
import FormDIDecaViewer from './FormDIDecaViewer';
import 'css/customDialog.css';
import { ENDPOINT } from 'constants/variables';
import { warningErrorAction } from 'actions/ErrorActions';

const HomeFormDIDeCA = ({ typeList }) => {
  const { t, i18n } = useTranslation(['listDataForms']);
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.loginUser.token);
  const enabled = useSelector((state) => state.loginUser.enabled);
  const roles = useSelector((state) => state.loginUser.roles);
  const defaultStore = useSelector((state) => state.loginUser.defaultStore);
  const [documentNumber, setDocumentNumber] = useState('');
  const [downloadingHistory, setDownloadingHistory] = useState(false);
  const listRoute = typeList === '1' ? '/formdi' : '/formdiended';
  const currentRoute = typeList === '1' ? `/formdideca/${id}` : `/formdidecaended/${id}`;

  const changeSelectedLanguage = () => {
    i18n.language === 'es' ? i18n.changeLanguage('en') : i18n.changeLanguage('es');
  };

  const handleFormDILoaded = useCallback((formdi) => {
    const number = formdi?.ownformdi_id
      || `${formdi?.preiddoc_sheet || ''}${formdi?.sufiddoc_sheet || ''}`;
    setDocumentNumber(number || id);
  }, [id]);

  const downloadHistory = async () => {
    if (!id || downloadingHistory) return;
    setDownloadingHistory(true);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 50000);
    try {
      const response = await fetch(`${ENDPOINT}/deca/documents/formdi/${id}/history/pdf`, {
        headers: { Authorization: `Bearer ${token}` }, signal: controller.signal
      });
      if (!response.ok) throw new Error('history-download');
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Historial_DeCA_DI_${documentNumber || id}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      dispatch(warningErrorAction('No se pudo descargar el historial completo del DeCA del DI'));
    } finally {
      clearTimeout(timeout);
      setDownloadingHistory(false);
    }
  };

  if (enabled === false) return <Navigate to="/home" />;

  return (
    <>
      <ImportScript resourceUrl="/js/sb-admin-2.min.js" />
      <ToastContainer />
      <div id="page-top"><div id="wrapper" className="formdi-list-page">
        <ul className="navbar-nav bg-gradient-primary toggled sidebar sidebar-dark accordion" id="accordionSidebar">
          <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/home">
            <div className="sidebar-brand-icon rotate-n-15"><DashboardIcon /></div>
            <div className="sidebar-brand-text mx-3">{t('Text_Title')}</div>
          </Link>
          <hr className="sidebar-divider my-0" />
          <li className="nav-item active"><div className="nav-link"><i className="fas fa-fw fa-tachometer-alt" /><span>{t('Menu_Main')}</span></div></li>
          <hr className="sidebar-divider" />
          {roles[0]?.listmenus?.find((key) => key.name === 'Menu_Settings') && (
            <li className="nav-item">
              <Link className="nav-link collapsed" to={currentRoute} data-toggle="collapse"
                data-target="#collapseAdmin" aria-expanded="true" aria-controls="collapseAdmin">
                <SettingsIcon /><span>{t('Menu_Settings')}</span>
              </Link>
              <div id="collapseAdmin" className="collapse" aria-labelledby="headingAdmin" data-parent="#accordionSidebar">
                <div className="bg-white py-2 collapse-inner rounded">
                  <h6 className="collapse-header">{t('Custom_Menu_Settings')}</h6>
                  <Link className="collapse-item" to={currentRoute} onClick={changeSelectedLanguage}>
                    {i18n.language === 'es' ? t('SubMenu_Settings_ChangeToEnglish') : t('SubMenu_Settings_ChangeToSpanish')}
                  </Link>
                </div>
              </div>
            </li>
          )}
          <li className="nav-item"><Link className="nav-link" to={listRoute}><LogoutIcon /><span>{t('Button_Back')}</span></Link></li>
          <hr className="sidebar-divider d-none d-md-block" />
          <div className="text-center d-none d-md-inline"><button className="rounded-circle border-0" id="sidebarToggle" /></div>
        </ul>
        <div id="content-wrapper" className="d-flex flex-column"><div id="content">
          <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
            <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3"><i className="fa fa-bars" /></button>
            <ul className="navbar-nav ml-auto">
              <Person /><div className="topbar-divider d-none d-sm-block" />
              <div className="driver-name-ok formdi-header-company"><br />{t('Text_StoreSelected')}&nbsp;
                {defaultStore.tradename === null ? t('Text_StoreEmpty') : defaultStore.tradename}</div>
              <div className="topbar-divider d-none d-sm-block" /><Alerts /><Messages />
              <div className="topbar-divider d-none d-sm-block" />
              <li className="nav-item dropdown no-arrow mx-1 formdi-header-date"><br /><span className="mr-2 d-none d-lg-inline text-gray-600 small"><TodayIs /></span></li>
            </ul>
          </nav>
          <div className="container-fluid email-send-wrapper formdi-deca-content">
            <div className="formdi-deca-layout">
              <div className="email-card-header"><div className="email-header-content">
                <div className="email-header-icon" style={{ color: '#ff8a00' }}><i className="fas fa-qrcode" /></div>
                <div className="email-header-text" style={{ flex: 1 }}>
                  <div className="email-header-title2">DeCA DOCUMENTO D.I.: {documentNumber || '…'}</div>
                </div>
                <div className="email-card-actions">
                  <button type="button" className="email-cancel-btn" onClick={downloadHistory}
                    disabled={!id || downloadingHistory} style={{ minWidth: '230px' }}>
                    {downloadingHistory
                      ? <><CircularProgress size={19} sx={{ color: '#4e73df', marginRight: '10px' }} /> Descargando…</>
                      : 'Descargar todo el historial'}
                  </button>
                  <button type="button" className="email-cancel-btn" onClick={() => navigate(listRoute)}>Retroceder</button>
                </div>
              </div></div>
              <div className="deca-view-card">
                <FormDIDecaViewer id={id} onFormDILoaded={handleFormDILoaded} />
              </div>
            </div>
          </div>
        </div><Footer /></div>
      </div></div>
    </>
  );
};

export default HomeFormDIDeCA;
